import { Button } from '@99designs/common/components/Button';
import { Icon } from '@99designs/common/components/Icon';
import { DesignerCard_User } from '__generated__/DesignerCard_User';
import { InviteDesignersPage_StructuredBrief } from '__generated__/InviteDesignersPage_StructuredBrief';
import { DesignerSource } from '__generated__/types';
import CardGrid from 'projects/components/CardGrid';
import { trackClickedShowMoreDesignersEvent, trackViewedDesignerEvent } from 'projects/events';
import React from 'react';
import DesignerCard from './DesignerCard';
import DesignerMetaContext from './DesignerMetaContext';

interface Props {
    brief: InviteDesignersPage_StructuredBrief;
}

interface State {
    pagesDisplayed: number;
    mergedDesignerResults: DesignerCard_User[];
}

export const DesignersPerPage = 15;

class DesignerResults extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        const mergedDesignerResults = props.brief.designers.concat(
            props.brief.relevantDesigners.filter(
                designers => !props.brief.designers.some(d => d.id === designers.id)
            )
        );

        this.state = {
            pagesDisplayed: 1,
            mergedDesignerResults,
        };
    }

    get shownDesigners() {
        return this.state.mergedDesignerResults.slice(
            0,
            this.state.pagesDisplayed * DesignersPerPage
        );
    }

    hasMoreResults() {
        return this.shownDesigners.length < this.props.brief.relevantDesigners.length;
    }

    render() {
        const { brief } = this.props;

        const relevantDesignerIds = brief.relevantDesigners.map(designer => {
            return designer.id;
        });
        return (
            <div className="designer-results">
                <div className="designer-results__results">
                    <CardGrid>
                        {this.shownDesigners.map((user, i) => (
                            <DesignerCard
                                key={user.id}
                                user={user}
                                isSelected={brief.designers.some(({ id }) => id === user.id)}
                                position={relevantDesignerIds.indexOf(user.id)}
                                designerSource={DesignerSource.RECOMMENDED}
                                onMount={() =>
                                    trackViewedDesignerEvent({
                                        id: brief.id,
                                        designer_id: user.id,
                                        designer_name: user.displayName,
                                        designer_level: user.profile.designerLevel,
                                        relevant_ranking: relevantDesignerIds.indexOf(user.id),
                                    })
                                }
                            />
                        ))}
                    </CardGrid>
                </div>
                {this.hasMoreResults() ? (
                    <div className="designer-results__pagination">
                        <Button
                            variations={['link']}
                            onClick={() => {
                                this.setState(
                                    state => ({
                                        pagesDisplayed: state.pagesDisplayed + 1,
                                    }),
                                    () => {
                                        trackClickedShowMoreDesignersEvent({
                                            id: brief.id,
                                            designers_per_page: DesignersPerPage,
                                            total_designers: this.shownDesigners.length,
                                        });
                                    }
                                );
                            }}
                        >
                            {__('Show more')}
                            <Icon type={'down-2'} variations={['offset-left']} />
                        </Button>
                    </div>
                ) : (
                    <DesignerMetaContext.Consumer>
                        {({ hasMoreResultsUrl }) =>
                            hasMoreResultsUrl && (
                                <div className="designer-results__pagination">
                                    {__("Haven't found your perfect match?")}{' '}
                                    <a href="/designers/search" className="link">
                                        {__('Choose your own designer')}
                                    </a>
                                </div>
                            )
                        }
                    </DesignerMetaContext.Consumer>
                )}
            </div>
        );
    }
}

export default DesignerResults;
